export default __webpack_public_path__ + "static/healthy-longevity-b34f4f1f7fa86ff80a94edc24a35ef84.jpg";